import React, { useEffect, useState } from 'react'
import { Player, BigPlayButton  } from 'video-react';
import { convertSecToMinute } from '../../../../utils/useWindowDimensions';
import axios from 'axios';
import VideoBG from '../../../../assets/images/pro/VideoBG.png'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';


const SupportingVideo =({userPlan, selectedVideo={}, videoList={} , setSelectedVideo})=> {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector(state => state.userSlice);
  let params = useParams()
  const moduleUUID = params.uuid;

  const updateVideo =(e)=>{
     setSelectedVideo({...e});
  }

  const handleContextMenu = (e) => {
    e.preventDefault();
  };


  return (
    <>
    <div className="container">
      { videoList.length > 0 ?
          userPlan?.courseDetail?.video ?
            <div className='module-frame'>
                <div className='playscreen'>
              
                  <div className='iframe forvideo' onContextMenu={handleContextMenu}>
                    {selectedVideo.file &&
                      <Player key={selectedVideo.file}>
                      <source src={selectedVideo.file} />
                      <BigPlayButton position="center" />
                    </Player>
                    }
                  </div>
                  </div>

                  <div className='module-info'>
                    <div className='video-list'>
                      <h5>Videos</h5>
                      <div className='video-list-scroll'>
                      {videoList.map((f,index) =>{
                        return(
                          <div className={f.file == selectedVideo.file ? 'videoitem active' : 'videoitem'} key={index}>
                          <img className='videoThumb' src={f.thumbnail} alt="" onClick={()=> updateVideo(f) } /> 
                          <span>
                            <p>{f.name}</p> 
                          <p>{convertSecToMinute(f.duration ? f.duration : 0)}</p>
                          </span>
                          </div> 
                              )
                      })}
                      </div>
                      </div>
                  </div>
              
              
            </div>
          :
          <div className='for-pro' style={{ aspectRatio:"auto" }}>
              <img src={VideoBG}/>
              <span className='cover-up'>

              </span>
              <div className='unlock-data'>
                  <h6>Unlock Features</h6>
                  <p>To access these additional features, <br/>
                  please <a> upgrade you plan. </a>
                  </p>
                  <button>Upgrade Plan</button>
              </div>
          </div>
          :
          <p>No videos found.</p>
      }
    </div>
    </>
  )
}


export default SupportingVideo